import { useRouter } from 'next/router';

import { web_path } from '@common/constants';

import { AuthSessionStorage, ConnectedSocialAccount } from '../utils';

interface CheckPasswordExistedInput {
  has_password: boolean;
  type: string;
  email: string;
  is_masked_email?: boolean;
  connected_social_account: ConnectedSocialAccount;
}

export const useSocialAccountError = () => {
  const { push } = useRouter();

  const checkPasswordExisted = (input: CheckPasswordExistedInput) => {
    const { has_password, type, email, is_masked_email, connected_social_account } = input;
    /** 계정 연결 페이지로 이동 */
    if (has_password) {
      const queryParams = new URLSearchParams({
        type,
        email,
        ...(is_masked_email && { is_masked_email: String(is_masked_email) }),
      });
      const url = `${web_path.auth.connect_account}?${queryParams.toString()}`;
      push(url);
    }

    /** 비밀번호가 없는 경우 다른 소셜 로그인 계정으로 로그인 하도록 유도 */
    if (!has_password && connected_social_account) {
      AuthSessionStorage.saveConnectedSocialAccount(connected_social_account);
      const url = web_path.auth.duplicate_social_account;
      push(url);
    }
  };

  return { checkPasswordExisted };
};
